import { render, staticRenderFns } from "./second-step-verification.vue?vue&type=template&id=4635ab37"
import script from "./second-step-verification.vue?vue&type=script&lang=js"
export * from "./second-step-verification.vue?vue&type=script&lang=js"
import style0 from "./second-step-verification.vue?vue&type=style&index=0&id=4635ab37&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports